export type MemoryUploadScope = 'org' | 'personal';

export interface MemoryUploadOption {
  scope: MemoryUploadScope;
  title: string;
  description: string;
  badge: string;
}

export const MEMORY_UPLOAD_OPTIONS: MemoryUploadOption[] = [
  {
    scope: 'personal',
    title: '个人知识库',
    description: '仅你和为你工作的 Agent 可以查看和使用',
    badge: 'PRIVATE',
  },
  {
    scope: 'org',
    title: '组织知识库',
    description: '组织成员和 Agent 共同使用',
    badge: 'SHARED',
  },
];
